import React from 'react';
import { Loading } from './Loading';
import { ErrorMessage } from './ErrorMessage';
import { Table } from './Table';
import { DrilldownRowsRenderer } from './DrilldownRowsRenderer';

export const DrilldownTable: React.FC<any> = ({
  isLoading,
  errorMessage,
  isMainTable,
  dataTable,
  className = 'data-table',
}) => {
  if (isLoading) return <Loading isRoot={isMainTable} className={className} />;

  if (errorMessage) return <ErrorMessage message={errorMessage} />;

  if (!dataTable) return <div />;

  return (
    <Table className={className} dataTable={dataTable} hasOptions={isMainTable}>
      <DrilldownRowsRenderer dataTable={dataTable} />
    </Table>
  );
};
